import { createResourceCollection } from '@/request'

export type EnrollmentHistoryEntry = {
  id: number
  created: string
  modified: string
  enrollment_type: number
  enrollment_id: number
  enrollment_type_name: string
  enrollment_info: {
    id: number
    created?: string
    program_name?: string
    device_type: string
    device_id?: number
  } | null
  current_status: string
  current_enrolled: boolean
  current_participation_status?: string
  current_eligibility_status?: string
  new_status: string
  new_enrolled?: boolean
  new_participation_status?: string
  new_eligibility_status?: string
  reason: string
  reasons: string[]
  source: string
  requirement_reasoning: string[]
}

export const adminEnrollmentHistoryCollection =
  createResourceCollection<EnrollmentHistoryEntry>({
    name: 'adminEnrollmentHistory',
    apiConfig: { path: 'admin/enrollment_history' },
    selector: (state) => state.adminEnrollmentHistory,
  })
